import React ,{useState, useEffect}from "react";
import SearchBar from "../../components/universal/SearchBar";
import { allchurchHeader } from "./Contsant";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate,useLocation } from "react-router-dom";
import { AllChurchHooks } from "./hooks/Ministryhooks";
import Navbar from "../../components/universal/Navbar";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";
import LoaderSpinner from "../../components/universal/LoaderSpinner";
import { useSelector } from "react-redux";
import ChurchModal from "./MinistryModal";
import { FaRegStar, FaStar } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useCallback } from "react";
import { updateMinistryRequest } from "../../store/Ministry/action"; // ✅ adjust path if needed
import { SUPER_ADMIN } from "../Users/Constants";

function AllVideos() {
  const navigate = useNavigate();
  const { value, onChangeSearchBar, handleDelete, reloadData, setReloadData,fetchAllChurches } =
  AllChurchHooks();
     const [isModalOpen, setIsModalOpen] = useState(false); // ✅ modal state
  const [selectedRow, setSelectedRow] = useState(null); // store clicked row
     const { userInfo } = useSelector((state) => state.user);
    const isSuperAdmin = userInfo?.roleCode === SUPER_ADMIN;
    const location = useLocation();
    const hideUI = location.pathname.includes("addfield")||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");
const dispatch = useDispatch();
const [featuredMinistries, setFeaturedMinistries] = useState(new Set());
const [ministryOptions, setMinistryOptions] = useState([]);
const [selectedMinistryId, setSelectedMinistryId] = useState("");
const tableHeaders = isSuperAdmin
  ? allchurchHeader
  : allchurchHeader.filter((header) => header.headerId !== "featuredColumn");
  useEffect(() => {
    setReloadData(true);
  }, [location.key, setReloadData]);
const updateMinistryWithFeatured = React.useCallback(
  (ministryData, isFeatured) => {
    return new Promise((resolve, reject) => {
      const payload = {
        _id: ministryData?._id,
        churchName: ministryData?.churchName,
        description: ministryData?.description,
        logourl: ministryData?.logourl,
        featured: isFeatured,
      };

      const callback = (res) => {
        if (res?.type === 1) {
          toast.success(
            isFeatured
              ? "Ministry added to featured"
              : "Ministry removed from featured"
          );
          resolve(res);
        } else {
          toast.error("Failed to update featured ministry");
          reject(res);
        }
      };

      dispatch(updateMinistryRequest(payload, callback));
    });
  },
  [dispatch]
);
const handleStarClick = React.useCallback(
  (ministry) => {
    const ministryId = ministry._id;
    const isFeatured = featuredMinistries.has(ministryId);
    const nextStatus = !isFeatured;

    // ⭐ optimistic UI
    setFeaturedMinistries((prev) => {
      const set = new Set(prev);
      nextStatus ? set.add(ministryId) : set.delete(ministryId);
      return set;
    });

    updateMinistryWithFeatured(ministry, nextStatus)
      .then(() => {
        setTimeout(() => {
          setReloadData((prev) => !prev);
        }, 400);
      })
      .catch(() => {
        // ❌ rollback if API fails
        setFeaturedMinistries((prev) => {
          const set = new Set(prev);
          isFeatured ? set.add(ministryId) : set.delete(ministryId);
          return set;
        });
      });
  },
  [featuredMinistries, updateMinistryWithFeatured, setReloadData]
);
const fetchAllMinistriesWithStars = React.useCallback(
  (page, limit, search, callbackFn) => {
    fetchAllChurches(page, limit, search, (response) => {
      if (!Array.isArray(response?.data)) {
        callbackFn?.(response);
        return;
      }
      setMinistryOptions(response.data);
      localStorage.setItem("ministryOptions", JSON.stringify(response.data));
      if (!selectedMinistryId && response.data.length > 0) {
        const firstId = response.data[0]?._id || "";
        setSelectedMinistryId(firstId);
        if (firstId) {
          localStorage.setItem("ministry", JSON.stringify(response.data[0]));
          window.dispatchEvent(new CustomEvent("ministry:change", { detail: response.data[0] }));
        }
      }

      // collect featured from API
      const featuredSet = new Set();
      response.data.forEach((item) => {
        if (item.featured === true) {
          featuredSet.add(item._id);
        }
      });
      setFeaturedMinistries(featuredSet);

      const transformedData = response.data.map((ministry) => {
        const isFeatured =
          ministry?.featured === true ||
          ministry?.featured === "true" ||
          ministry?.featured === 1 ||
          ministry?.featured === "1";

        return {
          ...ministry,
          isFeatured,
          ...(isSuperAdmin
            ? {
                featuredColumn: (
                  <div
                    className="flex justify-center items-center cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleStarClick(ministry);
                    }}
                    title={isFeatured ? "Remove from featured" : "Add to featured"}
                  >
                    {isFeatured ? (
                      <FaStar className="text-[#EFBC51] text-xl" />
                    ) : (
                      <FaRegStar className="text-gray-400 text-xl hover:text-[#EFBC51]" />
                    )}
                  </div>
                ),
              }
            : {}),
        };
      });

      callbackFn?.({
        ...response,
        data: transformedData,
      });
    });
  },
  [fetchAllChurches, handleStarClick, isSuperAdmin, selectedMinistryId]
);
const cleanRowData = useCallback((row) => {
    if (!row) return row;

    const cleanRow = { ...row };

    // Remove the featuredColumn if it exists (it contains React elements)
    if (cleanRow.featuredColumn) {
      delete cleanRow.featuredColumn;
    }

    // Remove any other React elements
    Object.keys(cleanRow).forEach(key => {
      const value = cleanRow[key];
      if (value && typeof value === 'object' && value.$$typeof) {
        delete cleanRow[key];
      }
    });

    // Also remove the isFeatured property we added
    if (cleanRow.isFeatured) {
      delete cleanRow.isFeatured;
    }

    return cleanRow;
  }, []);

const handleMinistrySelect = (ministryId) => {
  setSelectedMinistryId(ministryId);
  const selected = ministryOptions.find((c) => c?._id === ministryId);
  if (selected) {
    localStorage.setItem("ministry", JSON.stringify(selected));
    window.dispatchEvent(new CustomEvent("ministry:change", { detail: selected }));
  }
};
  return (
    <div className="App bg-[#191919] ">

      <Navbar />
      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full p-2">
          <SearchBar
            placeholder={"Search"}
            value={value}
            onChangeSearchBar={onChangeSearchBar}
            showMinistryDropdown={true}
            ministryOptions={ministryOptions}
            selectedMinistryId={selectedMinistryId}
            onChangeMinistry={handleMinistrySelect}
          />
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
              <p className=" text-white text-3xl font-medium">Ministries</p>
              <div className="flex gap-4">
                {/* <Link to={"/churches/add"}>
                  <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
                    <AiOutlinePlus /> Add Church
                  </button>
                </Link> */}
                <button
                  // onClick={() => setIsModalOpen(true)}
                  onClick={() => {
                    localStorage.removeItem("ministry");
                    window.dispatchEvent(
                      new CustomEvent("ministry:change", { detail: null })
                    );
                    navigate("/addMinistryField", {
                      state: { church: null, mode: "create" },
                    });
                  }}
                  className=" flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl "
                >
                  <AiOutlinePlus /> Add Ministry
                </button>
              </div>
            </div>
            <div className="relative bg-[#191919]">

                    {!isModalOpen?
              <CustomTable
                searchFor="Ministries"
                heightDesktop={"h-[72vh]"}
                width={"w-24"}
                // giving extra width to 2nd column
                nthChildWidth={
                  isSuperAdmin
                    ? "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-40 [&>*:nth-child(4)]:w-32"
                    : "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-32"
                }
                notificationTable={true}
                data={[]}
                headers={tableHeaders}
                customDataFetch={true}
                customDataFetchFunction={fetchAllMinistriesWithStars}
                reloadData={reloadData}
                setReloadData={setReloadData}
                handleDeleteClick={(row) => {
                  const options = {
                    customUI: ({ onClose }) => {
                      return (
                        <ConfirmToast
                          title="Are you sure?"
                          message="You want to delete this Ministry?"
                          onClose={() => {
                            onClose();                      // call the original close function
                          }}
                          reloadData={reloadData}
                          onSuccess={async () => {
                            try {
                              await handleDelete(row);
                              setReloadData((prev) => !prev);
                              onClose();
                            } catch (err) {
                                                            onClose();
                            }
                          }}
                        />
                      );
                    },
                    closeOnEscape: true,
                    closeOnClickOutside: true,
                    keyCodeForClose: [8, 32],
                    overlayClassName: "!bg-gray-500 !bg-opacity-75",
                  };

                  confirmAlert(options);

                }}
                reverseTable={true}
                nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
                handleToggleClick={(row, isActive) => {
                                  }}
                handleEyeClick={(row) => {
              //  setIsModalOpen(true)
              //  setSelectedRow(row);
               // store clicked row
                                    const cleanRow = cleanRowData(row);

                  navigate(`/addMinistryField`, {
                    state: {
                      church: cleanRow || "",
                    },
                  });
                }}
                handleEditClick={(row) => {
              //  setIsModalOpen(true)
              //  setSelectedRow(row);
               // store clicked row
                                    const cleanRow = cleanRowData(row);

                  navigate(`/addMinistryField`, {
                    state: {
                      church: cleanRow || "",
                    },
                  });
                }}
              />
              :''
}
            </div>
    <ChurchModal isOpen={isModalOpen}    onClose={() => { setIsModalOpen(false); setSelectedRow(null); }} rowData={selectedRow} // ✅ pass clicked row
    />

          </div>
         </div>
      </div>
     </div>
  );
}

export default AllVideos;
